export default "__VITE_ASSET__BDbc7H17__"